import { Optional } from "@angular/core";

export class ThirdPartyEvaluationStatus {
    thirdPartyId: number = 0;
    currentStageId: number = 0;
    totalWeight?: number = null;
    isFinalStage: boolean = false;
    isBeforeFinalStage: boolean = false;
    thirdPartyEvaluationId: number = 0;
    finalizeDate?: Date = null;
    rejectDate?: Date = null;
    isPendingOfAproval: boolean = false;
    isPendingOfExternalUserResponse: boolean = false;
    isPendingOfDueDiligenceProviderResponse: boolean = false;
    isPendingOfSendDueDiligenceRequest: boolean = false;
    isPendingOfReviewerResponse: boolean = false;
    showComments: boolean = false;
    formsCompleted: formsCompletedDto[] = [];
    statusId?: number;

    constructor() {
    }
}

export class formsCompletedDto {
    id: number;
    description: string;
    thirdPartyEvaluationId: number;
    appFormId: number;
    lastEvaluationStageId: number;
    observation: string;
    inProgress: boolean;
    completed: boolean;
    isExternalUserResponse: boolean;
    isExteralDueDiligence: boolean;
    swornDeclaration?: Date;
    thirdPartyEvaluationFormAnswers: formsCompletedAnswer[] = [];
    deletionDate?: Date;
}

export class formsCompletedAnswer {
    id: number = 0;
    description: string = '';
    thirdPartyEvaluationFormId: number = 0;
    appFormItemId: number = 0;
    appFormItemAnswerId: number = 0;
    observation: string = '';
    answerGridItems: formsCompletedAnswerGridItem[] = [];
    answerGridItemTotals: formsCompletedAnswerGridItemTotal[] = [];
}

export class formsCompletedAnswerGridItem {
    id: number;
    columnId: number;
    rowNumber: number;
    value = '';

    constructor() {
    }
}
export class formsCompletedAnswerGridItemTotal {
    id: number;
    columnId: number;
    value = '';

    constructor() {
    }
}

export class AnswerGrid {
    gridItem: formsCompletedAnswerGridItem[] = [];
    gridItemTotals: formsCompletedAnswerGridItemTotal[] = [];

    @Optional() get getUniqueRowNumbersLength(): number {
        return this.gridItem.map(item => item.rowNumber)
        .filter((value, index, self) => self.indexOf(value) === index).length
    }

    constructor() {
    }
}